import { Routes } from "@angular/router";
import { FullComponent } from "./layouts/full/full.component";
import { InicioViewComponent } from "./giz-layout/inicio/inicio-view/inicio-view.component";

export const AppRoutes: Routes = [
  {
    path: "",
    component: FullComponent,
    children: [
      // {
      //   path: '',
      //   redirectTo: '/dashboard',
      //   pathMatch: 'full'
      // },
      {
        path: "",
        redirectTo: "/inicio",
        pathMatch: "full",
      },
      {
        path: "inicio",
        component: InicioViewComponent,
      },
      {
        path: "",
        loadChildren: () =>
          import("./material-component/material.module").then(
            (m) => m.MaterialComponentsModule
          ),
      },
      {
        path: "dashboard",
        loadChildren: () =>
          import("./dashboard/dashboard.module").then((m) => m.DashboardModule),
      },
    ],
  },
];
